import GoogleAnalytics from './GoogleAnalytics'

export default GoogleAnalytics
export { gtag } from './GoogleAnalytics'
